export default __webpack_public_path__ + "static/media/carousel-img-5.e8c7d1d7.png";